import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function copyFromInput(input: HTMLInputElement) {
  input.select();
  document.execCommand("copy");
  return Promise.resolve();
}

function clip(link: string, input: HTMLInputElement | null): Promise<void> {
  return navigator.clipboard
    ? navigator.clipboard.writeText(link)
    : input
      ? copyFromInput(input)
      : Promise.reject();
}

function Clipeable(props: Props) {
  const fallBackRef = React.useRef<HTMLInputElement>(null);

  return (
    <div className={styles.clipeable}>
      <input
        type="text"
        ref={fallBackRef}
        className={styles.fallback}
        value={props.value}
        readOnly
      />
      {props.children(() =>
        clip(props.value, fallBackRef.current).then(props.clipEnd).catch(),
      )}
    </div>
  );
}

export { Clipeable, clip };
